import { TFunction } from 'i18next';
import * as Yup from 'yup';

const maxDoorNumberLength = 10;
const maxStreetAndLocalityLength = 50;

export const validationSchemaNL = (t: TFunction): Yup.ObjectSchema => {
    return Yup.object().shape({
        country: Yup.string(),
        postCode: Yup.string()
            .required(t('form.validation-error.postCode.required'))
            .matches(
                /^[0-9 a-zA-ZÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠšß]*$/i,
                t('form.validation-error.postCode.invalidCharacters'),
            )
            .matches(/^[0-9]{4}[ ][A-Z]{2}$/, t('form.validation-error.postCode.invalidFormatNL'))
            .min(6, t('form.validation-error.postCode.minLength', { value: 6 }))
            .max(10, t('form.validation-error.postCode.maxLength', { value: 10 })),
        houseNumber: Yup.string()
            .required(t('form.validation-error.houseNumber.required'))
            .matches(
                /^[\sa-zA-Záâäàãåéêëèíîïìóôöòõúüûùçñšß0-9- ]*$/i,
                t('form.validation-error.houseNumber.invalidCharacters'),
            )
            .min(1, t('form.validation-error.houseNumber.minLength', { value: 1 }))
            .max(10, t('form.validation-error.houseNumber.maxLength', { value: 10 })),

        door: Yup.string().trim().max(maxDoorNumberLength, t('form.validation-error.door-length')),
    });
};

export const validationSchema = (t: TFunction): Yup.ObjectSchema => {
    return Yup.object().shape({
        country: Yup.string(),
        postCode: Yup.string()
            .required(t('form.validation-error.postCode.required'))
            .matches(
                /^[0-9 a-zA-ZÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠšß]*$/i,
                t('form.validation-error.postCode.invalidCharacters'),
            )
            .min(6, t('form.validation-error.postCode.minLength', { value: 6 }))
            .max(10, t('form.validation-error.postCode.maxLength', { value: 10 })),
        houseNumber: Yup.string()
            .required(t('form.validation-error.houseNumber.required'))
            .matches(
                /^[\sa-zA-Záâäàãåéêëèíîïìóôöòõúüûùçñšß0-9- ]*$/i,
                t('form.validation-error.houseNumber.invalidCharacters'),
            )
            .min(1, t('form.validation-error.houseNumber.minLength', { value: 1 }))
            .max(10, t('form.validation-error.houseNumber.maxLength', { value: 10 })),
        door: Yup.string().trim().max(maxDoorNumberLength, t('form.validation-error.door-length')),
        street: Yup.string()
            .trim()
            .required(t('form.validation-error.street-required'))
            .max(maxStreetAndLocalityLength, t('form.validation-error.street-length')),
        locality: Yup.string()
            .trim()
            .required(t('form.validation-error.locality-required'))
            .max(maxStreetAndLocalityLength, t('form.validation-error.locality-length')),
    });
};
